import { Card, CardContent } from "azure-devops-ui/Card";
import { Icon } from "azure-devops-ui/Icon";
import * as React from "react";
import { Identity } from "../Identity";
import { IssueIcon } from "../IssueIcon";
import {
  Timeline,
  TimelineEntry,
  TimelineShowMore,
  TimelineSmallIcon,
  TimelineTimestamp
} from "../Timeline/Timeline";
import "./ActivityFeed.scss";
import { TextField } from "azure-devops-ui/TextField";
import { State } from "../State";

export const ActivityFeedEntryCreation: React.FC = () => {
  return (
    <TimelineEntry
      renderIcon={() => (
        <TimelineSmallIcon>
          <Icon iconName="WorkItem" />
        </TimelineSmallIcon>
      )}
    >
      <IssueIcon typeName="Bug" />
      &nbsp;<b>Bug #42</b>&nbsp;created by{" "}
      <Identity size={20} name="Christopher Schleiden" />
    </TimelineEntry>
  );
};

export const ActivityFeedAssignedTo: React.FC = () => {
  return (
    <TimelineEntry
      renderIcon={() => (
        <TimelineSmallIcon>
          <Icon iconName="Contact" />
        </TimelineSmallIcon>
      )}
    >
      Assigned to <Identity size={20} name="Celeste Burton" /> by{" "}
      <Identity size={20} name="Christopher Schleiden" />
    </TimelineEntry>
  );
};

export const ActivityFeedState: React.FC<{
  author: string;
  state: string;
  date: Date;
}> = ({ author, state, date }) => {
  return (
    <TimelineEntry
      renderIcon={() => (
        <TimelineSmallIcon>
          <Icon iconName="CircleRing" />
        </TimelineSmallIcon>
      )}
      date={date}
    >
      State changed to&nbsp;
      <State className="font-weight-semibold" state={state} />
      &nbsp;by <Identity size={20} name={author} />
    </TimelineEntry>
  );
};

///

export interface IActivityFeedCommentProps {
  author: string;
  date: Date;
  text: string;
}

export const ActivityFeedComment: React.FC<IActivityFeedCommentProps> = ({
  author,
  date,
  text
}) => {
  return (
    <TimelineEntry
      renderIcon={() => (
        <Identity
          className="comment-identity"
          name={author}
          size={32}
          showName={false}
        />
      )}
      className="flex-start"
    >
      <Card className="comment flex-grow">
        <CardContent contentPadding={false}>
          <div className="flex-column">
            <div className="flex-row">
              <span className="body-m font-weight-semibold">{author}</span>
              <TimelineTimestamp date={date} />
            </div>

            <div
              className="comment-content"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        </CardContent>
      </Card>
    </TimelineEntry>
  );
};

///

export const ActivityFeedCommentEntry: React.FC<{ author: string }> = ({
  author
}) => {
  return (
    <TimelineEntry
      renderIcon={() => (
        <Identity
          className="comment-identity"
          name={author}
          size={32}
          showName={false}
        />
      )}
      className="add-comment flex-start"
    >
      <div className="flex-grow">
        <TextField
          multiline={true}
          autoAdjustHeight={true}
          rows={3}
          placeholder="Add a comment..."
        />
      </div>
    </TimelineEntry>
  );
};

///

export const ActivityFeed: React.FC = () => {
  return (
    <Timeline>
      <ActivityFeedEntryCreation />
      <ActivityFeedComment
        author="Christopher Schleiden"
        date={new Date()}
        text={`<p>Once they had liked painting pictures with chemical fire, swimming in the canals in the seasons when the wine trees filled them with green liquors, and talking into the dawn together by the blue phosphorous portraits in the speaking room.</p>
<p>They were not happy now.</p>
<p>This morning Mrs. K stood between the pillars, listening to the desert sands heat, melt into yellow wax, and seemingly run on the horizon.
Something was going to happen.</p>`}
      />
      <ActivityFeedState
        author="Celeste Burton"
        state="Doing"
        date={new Date()}
      />
      <TimelineShowMore />
      <ActivityFeedComment
        author="Celeste Burton"
        date={new Date()}
        text={`<p>This looks good!</p>`}
      />
      <ActivityFeedAssignedTo />
      <ActivityFeedCommentEntry author="Christopher Schleiden" />
    </Timeline>
  );
};
